import { SubmitClaim } from "commonAssets/components/Forms/SubmitClaim";
import { generateMd5Hash } from "commonAssets/lib/generateMd5Hash";
import { validateField } from "commonAssets/lib/validateField";
import { ErrorHandler } from "commonAssets/utils/ErrorHandler";
import formDefault from "../../docs/formDefault.json";
import claimDeadlineAlertBody from "../../docs/html/claim_deadline_alert_body.html?raw";
import claimDeadlineAlertForm from "../../docs/html/claim_deadline_alert_form.html?raw";
import generalInstructionsBody from "../../docs/html/general_instructions_body.html?raw";
import contactInformationBody from "../../docs/html/contact_information_body.html?raw";

const htmlAssets = {
    "./html/claim_deadline_alert_body.html": claimDeadlineAlertBody,
    "./html/claim_deadline_alert_form.html": claimDeadlineAlertForm,
    "./html/general_instructions_body.html": generalInstructionsBody,
    "./html/contact_information_body.html": contactInformationBody,
};

export class customSubmitClaim extends SubmitClaim {
    async form() {
        const baseUrl = new URL(
            "../../docs/formDefault.json",
            window.location.href
        ).href;
        const config = await SubmitClaim.resolveHtmlFields(formDefault, {
            baseUrl,
            assets: htmlAssets,
        });
        const form = config.claim_form[this.lang];
        this.init_claim(form);
    }

    init_claim_files(claim) {
        document
            .getElementById("file-upload")
            .addEventListener("change", function () {
                if (validateField(this)) {
                    if (!this.files || !this.files[0]) {
                        document.getElementById("file-hash").value = "";
                        return;
                    }

                    generateMd5Hash(this.files[0], claim);
                    document.getElementById("file-description").focus();
                }
            });

        document.getElementById("file-add").addEventListener("click", () => {
            this.add_claim_file();
        });

        document
            .getElementById("file-description")
            .addEventListener("keypress", (e) => {
                if (["Enter", "NumpadEnter"].includes(e.code)) {
                    console.log(e.code);
                    this.add_claim_file();
                    e.preventDefault();
                }
            });
    }

    static createInstance({
        appClaimForm,
        userLanguage,
        customInitClaim = null,
        customProcessClaim = null,
        customLoadMember = null,
        customDstProcess = null,
        errorHandler = new ErrorHandler(),
    }) {
        return new customSubmitClaim(
            appClaimForm,
            userLanguage,
            customInitClaim,
            customProcessClaim,
            customLoadMember,
            customDstProcess,
            errorHandler
        );
    }
}
